import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import 'react-tabs/style/react-tabs.css'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import useCartStore from '../stores/cartStore'
import useOrderStore from '../stores/orderStore'
import useToastStore from '../stores/toastStore'
import cartService from '../services/cartService'

const Cart = () => {
    const { cart, fetchCart, updateCart, clearState } = useCartStore()
    const { createOrder } = useOrderStore()
    const [showModal, setShowModal] = useState(false)
    const { addToast } = useToastStore()
    const navigate = useNavigate()

    useEffect(() => {
        fetchCart()
    }, [fetchCart])

    const [dataHistory] = useState([
        {
            name: 'Admin',
            time: '2 hours ago',
            action: 'Delivery Item',
        },
        {
            name: 'You',
            time: '4 hours ago',
            action: 'Paid',
        },
        {
            name: 'Admin',
            time: '6 hours ago',
            action: 'Confirmed',
        },
        {
            name: 'You',
            time: '8 hours ago',
            action: 'Place Offer',
        },
    ])

    const handleOrderClick = () => {
        setShowModal(true)
    }

    const handleClose = () => {
        setShowModal(false)
    }

    const handleConfirm = async () => {
        const updateParams = {
            status: 'paid',
        }

        const result = await createOrder({ order: updateParams })

        if (result.success) {
            addToast('Update thành công!', 'success')
        } else {
            addToast(result.message, 'danger')
        }

        // TODO: Remove later
        navigate('/transaction-detail/1')
        clearState()
        handleClose()
    }

    const onRemove = async (itemId) => {
        try {
            const updatedCart = {
                id: cart.id,
                order_items_attributes: cart.order_items
                    .filter((orderItem) => orderItem.item.id !== itemId)
                    .map((orderItem) => ({
                        id: orderItem.id,
                        _destroy: false,
                    })),
            }
            updatedCart.order_items_attributes.push({
                id: cart.order_items.find((oi) => oi.item.id === itemId).id,
                _destroy: true,
            })

            await updateCart(updatedCart)

            if (updatedCart.order_items_attributes.filter((oi) => !oi._destroy).length === 0) {
                await cartService.deleteCart(cart.id)
                clearState()
                addToast('Giỏ hàng trống', 'success')
                return
            }

            addToast('Đã xóa sản phẩm khỏi giỏ hàng', 'success')
        } catch (error) {
            addToast('Không thể xóa sản phẩm', 'danger')
        }
    }

    if (!cart) {
        return (
            <div className="item-details">
                <Header />
                <div className="tf-section tf-item-details style-2">
                    <div className="themesflat-container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h3>Giỏ hàng trống</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }

    return (
        <div className="item-details">
            <Header />
            <div className="tf-section tf-item-details style-2">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div className="content-left">
                                {cart.order_items
                                    ? cart.order_items.map((orderItem) => {
                                          const { item } = orderItem
                                          return (
                                              <div key={item.id} className="sc-card-activity style1 cart-item">
                                                  <div className="content">
                                                      <div className="media">
                                                          <img src={item.images[0]?.url} alt={item.name} />
                                                      </div>
                                                      <div className="infor">
                                                          <h5>{item.name}</h5>
                                                          <div className="time">
                                                              <span>{`${item.float_num || ''} ${item.phase || ''}`}</span>
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div className="price">
                                                      <h5>{item.price} VNĐ</h5>
                                                  </div>
                                                  <button
                                                      className="sc-button style-2 mt-10 remove-item-from-cart"
                                                      onClick={() => onRemove(item.id)}
                                                  >
                                                      <i className="fas fa-trash"></i> Bỏ item
                                                  </button>
                                              </div>
                                          )
                                      })
                                    : 'No items'}
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="content-right">
                                <div className="sc-item-details">
                                    <div className="meta-item">
                                        <div className="left">
                                            <h2>Giỏ hàng</h2>
                                        </div>
                                    </div>
                                    <div className="meta-item-details">
                                        <div className="item-style-cart">
                                            <div className="item meta-price">
                                                <span className="heading">Thành tiền</span>
                                                <div className="price">
                                                    <div className="price-box">
                                                        <h5>{cart.total_price} VNĐ</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Link
                                        to="#"
                                        className="sc-button loadmore style bag fl-button pri-3"
                                        onClick={handleOrderClick}
                                    >
                                        <span> Đặt hàng</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton></Modal.Header>
                <div className="modal-body space-y-20 pd-40">
                    <h3>Đặt hàng vật phẩm</h3>
                    <p className="text-center">
                        <span className="price color-popup">Bạn có chắc chắn đặt đơn hàng này không?</span>
                    </p>
                    <button className="btn btn-primary" onClick={handleConfirm}>
                        Xác nhận
                    </button>
                    <button className="btn btn-cancel" onClick={handleClose}>
                        Huỷ
                    </button>
                </div>
            </Modal>
        </div>
    )
}

export default Cart
